import classNames from 'classnames';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { FAIcon } from '../../components/adapters/fontAwesomeAdapters';
import { InlineLink } from '../../components/typography';
import iconGrey from '../../resources/img/icons/map-circle-grey.png';
import iconYellow from '../../resources/img/icons/map-circle-yellow.png';
import iconBlue from '../../resources/img/icons/map-circle-blue.png';
import { useMonitorJobMapLegendStyles } from './MonitorJobMapLegend.styles';

export default function MonitorJobMapLegend() {
  const { styles } = useMonitorJobMapLegendStyles();
  const [isOpen, setOpen] = useState(true);
  return (
    <div
      className={classNames(styles.monitorMapLegend, {
        open: isOpen,
        closed: !isOpen,
      })}
    >
      <InlineLink
        className={styles.title}
        iconAfter={<FAIcon icon={isOpen ? 'caret-down' : 'caret-right'} />}
        onClick={() => setOpen(val => !val)}
      >
        <FormattedMessage id="monitor.map.legend" />
      </InlineLink>
      <div className={styles.text}>
        <div>
          <span className="label">
            <FormattedMessage id="monitor.map.legend.delivered" />
          </span>
          <span className="icon">
            <img src={iconGrey} alt="" />
            <FAIcon icon="check" />
          </span>
        </div>
        <div>
          <span className="label">
            <FormattedMessage id="monitor.map.legend.revisedETA" />
          </span>
          <span className="icon">
            <img src={iconYellow} alt="" />
            <FAIcon icon="exclamation" />
          </span>
        </div>
        <div>
          <div className="label">
            <FormattedMessage id="monitor.map.legend.nonDelivered" />
          </div>
          <div className="icon">
            <img src={iconBlue} alt="" />
            <div className="text-label">2</div>
          </div>
        </div>
      </div>
    </div>
  );
}
